// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `li:hover {
  cursor: pointer;
}
/* css hack to make only mozilla read below style and apply 
because firefox's default behavior shows li bullets closer to margin */
@-moz-document url-prefix() {
  li {
    margin-left: 11px;
  }
}
/* css hack to make only IE (10 and above) read below style and apply 
because ie's default behavior shows li bullets closer to margin */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  li {
    margin-left: 11px;
  }
}
/* css hack for ms edge for same reason*/
@supports (-ms-accelerator: true) {
  li {
    margin-left: 11px;
  }
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
